import {
  AsyncActionState,
  asyncActionStateMatchers,
  setupSlice,
  invoke,
} from '@owl-frontend/redux';
import statusApiClient from '../../api/status/client';
import type { Disruption } from '../../api/status/interface';

export interface StatusState {
  disruptions: Disruption[];
  actions: {
    fetchDisruptions: AsyncActionState<Disruption[]>;
  };
}

const initialState: StatusState = {
  disruptions: [],
  actions: {
    fetchDisruptions: { status: 'uninitialized' },
  },
};

const slice = setupSlice('status', initialState)
  .addAsyncSagas({
    fetchDisruptions: invoke(statusApiClient.fetchDisruptions),
  })
  .addReducers({
    'fetchDisruptions/fulfilled': (state, action) => {
      state.disruptions = action.payload;
    },
  });

export const actions = slice.actions;
export default slice.addExtra(asyncActionStateMatchers(actions).all());
